import type { BnbSettingsType } from "../redux/reducers/BnbSettingsReducer";
import { getBnbOptionalLabel } from "./labels";
import type { CommonSettingsType } from "../../../../common-deprecated/settings/fetchCommonSettings";

export const getEvDisclaimer = (
    commonSettings: CommonSettingsType,
    bnbSettings: BnbSettingsType,
    engineCode: string,
): string | null => {
    const evDisclaimerLabel = getBnbOptionalLabel({ commonSettings, bnbSettings }, "disclaimerEv");
    return engineCode.toLowerCase().includes("percombined") ? evDisclaimerLabel : null;
};
